import { gql } from "@apollo/client";

export const PROMO_CODE_FRAGMENT = gql`
  fragment PromoCodeFragment on PromotionCode {
    name
    code
    active
    amountOff
    percentOff
    redemptionText
  }
`;
